import { render, staticRenderFns } from "./AddonSpecialityTable.vue?vue&type=template&id=16ae00f5&"
import script from "./AddonSpecialityTable.vue?vue&type=script&lang=js&"
export * from "./AddonSpecialityTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports